<div class="mg-layout">
  <div class="mg-layout__toolbar" *ngIf="stateAuth">
    <mg-toolbar
      [viewNotifications]="viewNotifications"
      [notification]="notification"
      (sidebar)="statusSidebar($event)"
      [url]="url"
      [user]="user"
      [showModules]="showModules"
      [modules]="modules"
      [showMenu]="status"
    ></mg-toolbar>
  </div>
  <div class="mg-layout__content">
    <div class="mg-layout__content__sidebar">
      <mg-sidebar
        [version]="version"
        [modulesToolbar]="modules"
        [showModules]="showModules"
        *ngIf="stateAuth"
        (menu)="statusSidebar($event)"
        [listSidebar]="listSidebar"
        [statusMenu]="status"
        [ids]="ids"
      ></mg-sidebar>
    </div>
    <div
      class="mg-layout__content__router"
      [ngClass]="{ 'mg-layout__content__router--full': stateAuth }"
    >
      <ng-content select="[mg-header]" *ngIf="stateAuth"></ng-content>
      <ng-content select="[mg-router]"></ng-content>
      <ng-content select="[mg-footer]" *ngIf="stateAuth"></ng-content>
    </div>
  </div>
</div>
<app-splash *ngIf="loading"></app-splash>
